/**
 * HTML-escape a string so it can be safely inserted into markup.
 * @param {string} value - Raw text.
 * @returns {string} Escaped text.
 */
export function escapeHtml(value) {
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

/**
 * Convert arbitrary user input into a URL-friendly slug.
 * @param {string} value - Input text.
 * @returns {string} Slug with ASCII lowercase letters/numbers.
 */
export function slugify(value) {
	return String(value || '')
		.normalize('NFKD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+/, '')
		.replace(/-+$/, '');
}

/**
 * Pull the first Markdown H1 line from a document.
 * @param {string} markdown - Markdown source string.
 * @returns {string|null} The heading content or null if none found.
 */
export function extractTitleFromMarkdown(markdown) {
	if (typeof markdown !== 'string') {
		return null;
	}
	const match = markdown.match(/^\s*#\s+(.+?)\s*$/m);
	if (!match) {
		return null;
	}
	return match[1].trim();
}

/**
 * Convert a slug or path segment into a human-friendly title.
 * @param {string} slug - Slug or path identifier.
 * @returns {string} Formatted title suitable for headings.
 */
export function formatTitleFromSlug(slug) {
	if (!slug) {
		return 'Lore';
	}
	const base = slug.split('/').pop();
	const words = base
		.replace(/[-_]+/g, ' ')
		.replace(/\s+/g, ' ')
		.trim()
		.split(' ');
	for (let i = 0; i < words.length; i += 1) {
		const word = words[i];
		words[i] = word.charAt(0).toUpperCase() + word.slice(1);
	}
	return words.join(' ') || 'Lore';
}
